import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import ConciliacionFacturas from "../../components/conciliacionFacturas";
import Layout from "../../components/layout";

interface Props {}

class ConciliacionFacturasPage extends React.Component<Props> {
  state = {
    classifications: []
  };

  componentDidMount() {}

  render() {
    return (
      <main>
        <Helmet title="" />
        <Layout>
          <ConciliacionFacturas />
        </Layout>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConciliacionFacturasPage);
